import { useState, useContext, useEffect, forwardRef } from "react";
import {
  Grid,
  Typography,
  List,
  ListItem,
  Dialog,
  AppBar,
  Toolbar,
  DialogContent,
  Slide,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import ManualInvoice from "../../../components/ManualInvoice";
import { EventContext } from "../../../contexts/EventContext";
import request from "../../../utilities/requests";
import formatDate from "../../../utilities/formatDate";
import { toast } from "../../../utilities/SnackBarUtils";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Uninvoiced = ({ open, close }) => {
  const { userData } = useContext(EventContext);
  const [data, setData] = useState([]);
  const [manualOpen, setManualOpen] = useState(false);
  const [manualEvent, setManualEvent] = useState(null);

  useEffect(() => {
    if (open && userData?.role === "superadmin") {
      getData();
    }
  }, [open]);

  const getData = async () => {
    const result = await request("contracts/uninvoiced");
    if (result.success) {
      setData(result.data);
    }
  };

  const createInvoice = async (eventId) => {
    const url = `contracts/invoice/calculate/${eventId}`;
    const result = await request(url);
    if (result.success) {
      getData();
      toast.success("Invoice created successfully");
    }
  };

  const handleManual = async (eventId) => {
    setManualEvent(eventId);
    setManualOpen(true);
  };

  const markNotChargeable = async (eventId) => {
    const body = {
      eventId,
      update: { invoiceStatus: "notChargeable" },
    };
    const result = await request("events/update", "post", body);
    if (result.success) {
      getData();
      toast.success("Invoice marked as non-chargeable");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={close}
      TransitionComponent={Transition}
      fullScreen
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={close}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Uninvoiced Events
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <List>
          {data.map((event) => {
            return (
              <ListItem key={event?._id}>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  justifyContent="space-between"
                >
                  <Grid item xs={1}>
                    <Typography>{event?.org}</Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography>{formatDate(event?.date)}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography>{event?.name}</Typography>
                  </Grid>
                  {/* <Grid item xs={2}>
                    <Typography variant="caption">{event?._id}</Typography>
                  </Grid> */}
                  <Grid item xs={1}>
                    <Button
                      size="small"
                      onClick={() => createInvoice(event._id)}
                    >
                      Create Invoice
                    </Button>
                  </Grid>
                  <Grid item xs={1}>
                    <Button
                      size="small"
                      onClick={() => handleManual(event._id)}
                    >
                      Manual Invoice
                    </Button>
                  </Grid>
                  <Grid item xs={1}>
                    <Button
                      size="small"
                      onClick={() => markNotChargeable(event._id)}
                    >
                      Not Chargeable
                    </Button>
                  </Grid>
                </Grid>
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
      <ManualInvoice
        open={manualOpen}
        close={() => {
          setManualOpen(false);
          setManualEvent(null);
        }}
        eventId={manualEvent}
      />
    </Dialog>
  );
};

export default Uninvoiced;
